/* ============================================================
   C°LD theme scripts
   - AJAX cart + drawer
   - Automatic DPG-Pfand line synchronisation
   - Hero flavour takeover
   - Variant picker
   ============================================================ */
(function () {
  'use strict';

  var CFG = window.COLD || {};
  
  var money = function (cents) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return (CFG.currencySymbol || '€') + v;
  };
  /* ---------------- Utilities ---------------- */
  function on(sel, evt, fn, root) {
    (root || document).addEventListener(evt, function (e) {
      var t = e.target.closest(sel);
      if (t) fn(e, t);
    });
  }
  function fetchJSON(url, opts) {
    return fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } }, opts))
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  /* ============================================================
     PFAND SYNC
     Shopify cannot show a legally separate deposit line natively,
     so the deposit is carried as its own product. This keeps that
     line exactly in step with the number of deposit-bearing cans
     in the cart. Configure the variant id in theme settings.
     ============================================================ */
  var Pfand = {
    variantId: CFG.pfandVariantId ? String(CFG.pfandVariantId) : null,

    unitsInCart: function (cart) {
      var units = 0;
      cart.items.forEach(function (item) {
        if (String(item.variant_id) === Pfand.variantId) return;
        var per = 0;
        // Set via product metafield custom.deposit_units, exposed as a line property fallback.
        if (item.properties && item.properties._pfand_units) per = parseInt(item.properties._pfand_units, 10) || 0;
        units += per * item.quantity;
      });
      return units;
    },

    sync: function (cart) {
      if (!Pfand.variantId) return Promise.resolve(cart);
      var want = Pfand.unitsInCart(cart);
      var line = null, index = 0;
      cart.items.forEach(function (item, i) {
        if (String(item.variant_id) === Pfand.variantId) { line = item; index = i + 1; }
      });
      var have = line ? line.quantity : 0;
      if (want === have) return Promise.resolve(cart);

      if (line) {
        return fetchJSON('/cart/change.js', {
          method: 'POST',
          body: JSON.stringify({ line: index, quantity: want })
        });
      }
      if (want > 0) {
        return fetchJSON('/cart/add.js', {
          method: 'POST',
          body: JSON.stringify({ items: [{ id: Pfand.variantId, quantity: want }] })
        }).then(function () { return fetchJSON('/cart.js'); });
      }
      return Promise.resolve(cart);
    }
  };

  /* ============================================================
     CART
     ============================================================ */
  var Cart = {
    refresh: function () {
      return fetchJSON('/cart.js')
        .then(Pfand.sync)
        .then(function (cart) {
          Cart.render(cart);
          document.dispatchEvent(new CustomEvent('cold:cart', { detail: cart }));
          return cart;
        });
    },

    add: function (formData) {
      return fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { return Cart.refresh(); })
        .then(function (cart) { Drawer.open(); return cart; });
    },

    change: function (line, quantity) {
      return fetchJSON('/cart/change.js', {
        method: 'POST',
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function () { return Cart.refresh(); });
    },

    render: function (cart) {
      // badge
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        var visible = 0;
        cart.items.forEach(function (i) {
          if (String(i.variant_id) !== Pfand.variantId) visible += i.quantity;
        });
        el.textContent = visible;
        el.hidden = visible === 0;
      });
      // drawer contents via Section Rendering API
      var body = document.querySelector('[data-drawer-body]');
      if (!body) return;
      fetch('/?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
          var fresh = html.querySelector('[data-drawer-inner]');
          var target = document.querySelector('[data-drawer-inner]');
          if (fresh && target) target.innerHTML = fresh.innerHTML;
        })
        .catch(function () { /* drawer will refresh on next page load */ });
    }
  };

  /* ============================================================
     DRAWER + OVERLAY
     ============================================================ */
  var Drawer = {
    el: null, overlay: null, lastFocus: null,
    init: function () {
      Drawer.el = document.querySelector('[data-cart-drawer]');
      Drawer.overlay = document.querySelector('[data-overlay]');
      if (!Drawer.el) return;
      on('[data-open-cart]', 'click', function (e) { e.preventDefault(); Drawer.open(); });
      on('[data-close-cart]', 'click', function (e) { e.preventDefault(); Drawer.close(); });
      if (Drawer.overlay) Drawer.overlay.addEventListener('click', Drawer.close);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { Drawer.close(); MobileNav.close(); }
      });
    },
    open: function () {
      if (!Drawer.el) return;
      Drawer.lastFocus = document.activeElement;
      Drawer.el.classList.add('is-open');
      Drawer.el.setAttribute('aria-hidden', 'false');
      if (Drawer.overlay) Drawer.overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var close = Drawer.el.querySelector('[data-close-cart]');
      if (close) close.focus();
    },
    close: function () {
      if (!Drawer.el) return;
      Drawer.el.classList.remove('is-open');
      Drawer.el.setAttribute('aria-hidden', 'true');
      if (Drawer.overlay) Drawer.overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      if (Drawer.lastFocus) Drawer.lastFocus.focus();
    }
  };

  /* ============================================================
     MOBILE NAV
     ============================================================ */
  var MobileNav = {
    el: null,
    init: function () {
      MobileNav.el = document.querySelector('[data-mobile-nav]');
      on('[data-toggle-nav]', 'click', function (e) {
        e.preventDefault();
        MobileNav.el.classList.toggle('is-open');
        document.body.style.overflow = MobileNav.el.classList.contains('is-open') ? 'hidden' : '';
      });
    },
    close: function () {
      if (MobileNav.el) { MobileNav.el.classList.remove('is-open'); document.body.style.overflow = ''; }
    }
  };

  /* ============================================================
     HERO FLAVOUR TAKEOVER
     Drives the fan-out intro (is-revealing / is-fanned / is-settling
     classes, defined in theme.css) once on load. The lifted/settled
     look (is-revealing + is-settling) is then kept on permanently —
     only is-fanned and is-active toggle afterwards — so every later
     rotation eases through the exact same two states as the intro's
     end, with no hand-off snap.
     ============================================================ */
  function initHero() {
    var hero = document.querySelector('[data-hero]');
    if (!hero) return;
    var buttons = hero.querySelectorAll('[data-flavour]');
    var cans = hero.querySelectorAll('[data-flavour-can]');
    if (!buttons.length) return;

    // Clear any previous rotation loop / reveal timers on this hero —
    // guards against the theme editor or page builder re-running this
    // function against the same (or a stale) node without a full reload.
    if (hero._coldHeroInterval) { clearInterval(hero._coldHeroInterval); }
    if (hero._coldHeroTimers) { hero._coldHeroTimers.forEach(clearTimeout); }
    hero._coldHeroTimers = [];
    hero.classList.remove('is-revealing', 'is-settling');
    cans.forEach(function (c) { c.classList.remove('is-fanned'); });

    function select(key) {
      buttons.forEach(function (b) {
        var active = b.dataset.flavour === key;
        b.setAttribute('aria-selected', active ? 'true' : 'false');
        b.classList.toggle('is-lifted', active);
      });
      cans.forEach(function (c) {
        c.classList.toggle('is-active', c.dataset.flavourCan === key);
      });
    }

    var firstKey = buttons[0].dataset.flavour;
    select(firstKey);

    function startRotation() {
      var auto = true, i = 0;
      hero._coldHeroInterval = setInterval(function () {
        if (!auto) return;
        i = (i + 1) % buttons.length;
        select(buttons[i].dataset.flavour);
      }, 3800);

      buttons.forEach(function (b) {
        b.addEventListener('click', function () { select(b.dataset.flavour); auto = false; });
        b.addEventListener('mouseenter', function () { select(b.dataset.flavour); });
      });
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      // Skip the fan reveal for people who don't want motion — go
      // straight to the steady, single-can state.
      startRotation();
      return;
    }

    // ---- Fan-out reveal, once on load ----
    // 1) Let the browser paint the resting (hidden) state first, so the
    //    reveal always has a frame to transition from.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        hero.classList.add('is-revealing');

        // 2) Fan the non-active cans out to their offset positions.
        hero._coldHeroTimers.push(setTimeout(function () {
          cans.forEach(function (c) {
            if (!c.classList.contains('is-active')) c.classList.add('is-fanned');
          });
        }, 150));

                // 3) Hold the fan briefly, then retract and fade the extra cans
        //    together in the same instant — one continuous motion back
        //    to centre, not a static hold followed by a separate fade.
        hero._coldHeroTimers.push(setTimeout(function () {
          hero.classList.add('is-settling');
          cans.forEach(function (c) { c.classList.remove('is-fanned'); });
        }, 1500));

        // 4) is-revealing/is-settling stay on permanently, so the active
        //    can is already exactly where normal rotation expects it.
        //    No jump at the hand-off.
        hero._coldHeroTimers.push(setTimeout(function () {
          startRotation();
        }, 2300));
      });
    });
  }

  /* ============================================================
     PRODUCT — variant picker + gallery
     ============================================================ */
  function initProduct() {
    var form = document.querySelector('#product-form');
    if (!form) return;
    var root = form.closest('[data-product-root]') || document;
    var data = root.querySelector('[data-product-json]');
    if (!data) return;
    var product = JSON.parse(data.textContent);
    var idInput = form.querySelector('[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var depositEl = root.querySelector('[data-deposit]');
    var submit = form.querySelector('[data-add]');

    function currentOptions() {
      return Array.prototype.map.call(root.querySelectorAll('[data-option-group]'), function (g) {
        var sel = g.querySelector('[aria-checked="true"]');
        return sel ? sel.dataset.value : null;
      });
    }
    function match(opts) {
      return product.variants.find(function (v) {
        return opts.every(function (o, i) { return !o || v.options[i] === o; });
      });
    }
    function update() {
      var v = match(currentOptions());
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (depositEl && depositEl.dataset.perUnit) {
        var units = parseInt(v.deposit_units || depositEl.dataset.units || 0, 10);
        var per = parseInt(depositEl.dataset.perUnit, 10);
        depositEl.querySelector('[data-deposit-value]').textContent = money(units * per);
      }
      if (submit) {
        submit.disabled = !v.available;
        submit.querySelector('span').textContent = v.available
          ? (CFG.strings.addToCart || 'In den Warenkorb')
          : (CFG.strings.soldOut || 'Ausverkauft');
      }
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url);
      }
    }

    on('[data-value]', 'click', function (e, btn) {
      var group = btn.closest('[data-option-group]');
      group.querySelectorAll('[data-value]').forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
      btn.setAttribute('aria-checked', 'true');
      update();
    }, root);

    // quantity stepper
    on('[data-qty]', 'click', function (e, btn) {
      var input = btn.parentElement.querySelector('input');
      var next = parseInt(input.value, 10) + parseInt(btn.dataset.qty, 10);
      input.value = Math.max(1, next);
    }, root);

    // gallery thumbs
    on('[data-thumb]', 'click', function (e, btn) {
      var main = root.querySelector('[data-main-image]');
      if (main) { main.src = btn.dataset.thumb; main.srcset = ''; }
      root.querySelectorAll('[data-thumb]').forEach(function (b) { b.setAttribute('aria-selected', 'false'); });
      btn.setAttribute('aria-selected', 'true');
    }, root);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (submit) { submit.setAttribute('aria-disabled', 'true'); submit.querySelector('span').textContent = CFG.strings.adding || 'Wird hinzugefügt…'; }
      Cart.add(new FormData(form))
        .catch(function (err) {
          var msg = root.querySelector('[data-form-error]');
          if (msg) { msg.textContent = (err && err.description) || CFG.strings.error; msg.hidden = false; }
        })
        .finally(function () {
          if (submit) { submit.removeAttribute('aria-disabled'); submit.querySelector('span').textContent = CFG.strings.addToCart || 'In den Warenkorb'; }
        });
    });

    update();
  }

  /* ============================================================
     CART PAGE / DRAWER INTERACTIONS
     ============================================================ */
  function initCartControls() {
    on('[data-line-change]', 'click', function (e, btn) {
      e.preventDefault();
      Cart.change(parseInt(btn.dataset.line, 10), parseInt(btn.dataset.lineChange, 10));
    });
    on('[data-line-remove]', 'click', function (e, btn) {
      e.preventDefault();
      Cart.change(parseInt(btn.dataset.lineRemove, 10), 0);
    });
    document.addEventListener('cold:cart', function () {
      if (document.body.classList.contains('template-cart')) window.location.reload();
    });
  }

  /* ============================================================
     STICKY HEADER + REVEALS
     ============================================================ */
  function initChrome() {
    var header = document.querySelector('[data-header]');
    if (header) {
      var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > 12); };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      document.querySelectorAll('[data-reveal]').forEach(function (el) { io.observe(el); });
    } else {
      document.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-in'); });
    }
  }

  /* ---------------- Boot ---------------- */
  function bootAll() {
    Drawer.init();
    MobileNav.init();
    initHero();
    initProduct();
    initCartControls();
    initChrome();
    Cart.refresh();
  }

  document.addEventListener('DOMContentLoaded', bootAll);

  // If the theme editor or page builder swaps the hero section's markup
  // back in without a full page reload, re-run initHero so the reveal
  // and rotation re-attach to the fresh elements.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-hero]')) {
      initHero();
    }
  });

  window.COLDCart = Cart;
})();
